import Vue from 'vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import '@/plugins/vee-validate/rules';

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
